import React from "react";
import "./Smm.css";
import ScrollToTop from "../components/ScrollToTop";
import { useNavigate } from "react-router-dom";

import smmHero from "../assets/SMM_hero.png";
import organicSocialImg from "../assets/SMM.jpeg";

// placeholders (change later)
import paidSearchImg from "../assets/search.webp";
import paidSocialImg from "../assets/social ads.png";
import paidVideoImg from "../assets/video ads.jpeg";

const SMM = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate("/contact");
  };

  return (
    <section className="service-page smm-page">
      <ScrollToTop />

      {/* ================= HERO SECTION ================= */}
      <div className="smm-hero">
        <div className="smm-hero-inner">
          <div className="smm-hero-content">
            <h1 className="smm-hero-title">
              <span className="smm-highlight">Social Media Management</span> That
              Builds Trust & Drives Growth
            </h1>

            <p className="smm-hero-description">
              We help brands grow visibility, engagement, and conversions through
              data driven social media strategies. From content and community
              management to paid campaigns and reporting, we build consistent
              performance across platforms where your audience spends time.
            </p>

            <button className="smm-hero-btn" onClick={handleLearnMore}>
              Get In Touch
            </button>
          </div>

          <div className="smm-hero-image">
            <img src={smmHero} alt="Social Media Marketing Hero" />
          </div>
        </div>
      </div>

      {/* ================= PAGE CONTENT ================= */}
      <div className="smm-content-container">
        {/* ================= ORGANIC SOCIAL ================= */}
        <section className="smm-section organic-social">
          <h2 className="smm-section-title">Organic Social</h2>

          <p className="smm-section-subtitle">
            Organic Social helps your brand grow naturally by creating engaging
            content, building real connections, and turning followers into loyal
            customers.
          </p>

          <div className="organic-social-grid">
            <div className="organic-social-image">
              <img src={organicSocialImg} alt="Organic Social Media" />
            </div>

            <div className="organic-social-content">
              <ul className="organic-social-list">
                <li>
                  <strong>Grow Naturally. Build Trust.</strong>
                </li>
                <li>Content planning & monthly calendars</li>
                <li>Posts, reels & engaging captions</li>
                <li>Hashtag + trend strategy</li>
                <li>Community management (comments & DMs)</li>
                <li>Consistent brand voice</li>
              </ul>
            </div>
          </div>
        </section>

        {/* ================= PAID SOCIAL ================= */}
        <section className="smm-section paid-social">
          <h2 className="smm-section-title">Paid Social</h2>

          <p className="smm-section-subtitle">
            Run performance campaigns that generate leads quickly with clear
            targeting, clean creatives, and measurable ROI.
          </p>

          <div className="paid-cards-grid">
            {/* Card 1 */}
            <article className="paid-card">
              <div className="paid-card-media">
                <img src={paidSearchImg} alt="Search Ads" />
              </div>

              <div className="paid-card-body">
                <h3 className="paid-card-title">🔍 Search Ads</h3>

                <ul className="paid-card-list">
                  <li>
                    Show your business to people actively searching on Google
                  </li>
                  <li>Use buyer keywords + service specific landing pages</li>
                  <li>Track calls, forms & WhatsApp clicks</li>
                </ul>

                <p className="paid-card-result">
                  <span>Result:</span> High intent leads, faster enquiries.
                </p>
              </div>
            </article>

            {/* Card 2 */}
            <article className="paid-card">
              <div className="paid-card-media">
                <img src={paidSocialImg} alt="Social Ads" />
              </div>

              <div className="paid-card-body">
                <h3 className="paid-card-title">📲 Social Ads</h3>

                <ul className="paid-card-list">
                  <li>Reach the right audience by location & interests</li>
                  <li>Simple creatives + quick lead forms / WhatsApp</li>
                  <li>Retarget visitors and engaged users</li>
                </ul>

                <p className="paid-card-result">
                  <span>Result:</span> Strong visibility with steady leads.
                </p>
              </div>
            </article>

            {/* Card 3 */}
            <article className="paid-card">
              <div className="paid-card-media">
                <img src={paidVideoImg} alt="Video Ads" />
              </div>

              <div className="paid-card-body">
                <h3 className="paid-card-title">🎥 Video Ads</h3>

                <ul className="paid-card-list">
                  <li>Short videos that explain your service clearly</li>
                  <li>Run campaigns on YouTube</li>
                  <li>Retarget viewers with lead ads</li>
                </ul>

                <p className="paid-card-result">
                  <span>Result:</span> Higher trust and better conversions.
                </p>
              </div>
            </article>
          </div>
        </section>

        {/* ================= WHY CHOOSE ================= */}
        <section className="smm-section why-choose">
          <div className="why-choose-card">
            <h2 className="why-choose-title">Why Choose THE WE DEV ?</h2>

            <ul className="why-choose-list">
              <li>Strategic Social Media Management</li>
              <li>High Quality, Brand Led Content</li>
              <li>Data Backed Performance Optimization</li>
              <li>Consistent & Scalable Brand Presence</li>
            </ul>
          </div>
        </section>
      </div>
    </section>
  );
};

export default SMM;
